
interface WeightUnitDisplayProps {
  lastSyncTime: number | null;
  isSyncing: boolean;
}

export const WeightUnitDisplay = ({ lastSyncTime, isSyncing }: WeightUnitDisplayProps) => {
  return (
    <div className="ml-2 flex items-center gap-1">
      <span className="text-xs text-gray-300">kg</span>
    </div>
  );
};
